var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"156af154751cff8f228084bff3aa364e320d6e63"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["elo-cabinets@ablefy"]={id:"156af154751cff8f228084bff3aa364e320d6e63"};
      